//お知らせ一覧の絞り込み

let selectedYear = ''; // グローバル変数として選択された年を保持

// 年別リンク
$('#js-select-year').on('change', function() {
  let _obj = $(this).find('option:selected');
  selectedYear = _obj.data('year'); // 選択された年をグローバル変数に保持
  let _link = _obj.attr('value');
  let _category = $('.l-notice__categoryBtn.is-current').data('category');
  if (_category) {
    window.location.href = _link + '?notice_cat=' + _category;
  } else {
    window.location.href = _link;
  }
});

// カテゴリーボタンのクリックイベントを設定(TOPにも同じボタンがあるのでそれは除く)
if (document.body.classList.contains('p-notice')) {
	$('.l-notice__categoryBtn').on('click', function(event) {
		event.preventDefault();
		let _obj = $(this);
		let _category = _obj.data('category');
		if (selectedYear) {
			if (_category) {
				let yearParam = selectedYear;
				window.location.href = '/notice/date/' + yearParam + '/?notice_cat=' + _category;
			} else {
				window.location.href = '/notice/date/' + selectedYear + '/';
			}
		} else {
			if (_category) {
				window.location.href = '/notice/?notice_cat=' + _category;
			} else {
				window.location.href = '/notice/';
			}
		}
	});
}
